module.exports = __webpack_public_path__ + "img/start-install-icon.aab0b7df.svg";